import React from 'react';
import logoImage from '../../assets/eat-ezy-logo.png';

const EatEzyLogo = ({ size = 'default', className = '', showTagline = true }) => {
  const sizeClasses = {
    small: 'w-12 h-6',
    default: 'w-20 h-10',
    large: 'w-28 h-14',
    xlarge: 'w-36 h-18'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoImage}
        alt="eatEzy - Digital Menu & Delivery App"
        className={`${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};

export default EatEzyLogo;
